import { IMain, IServiceControl } from 'src/@types/apiResponse';
import { ICodeGroupModel, ICommonCd } from 'src/models';

import { TApiResponseData } from '../apiTypes';
import instance from '../axios';

/* 전체 공통 코드 목록 조회 */
export const getCommonCds = async () => {
  try {
    const url = `/commonCd`;
    const response = await instance.get<TApiResponseData<ICodeGroupModel[]>>(url);

    if (response.data.resultCode === 'S' && response.data.data) {
      return response.data.data;
    }

    return [];
  } catch (error) {
    console.error(error);
  }
};

/* 홈 화면 조회 */
export const getMain = async () => {
  try {
    const url = `/user/main`;
    const response = await instance.get<TApiResponseData<IMain>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/* 자식 코드 목록 조회 */
export const getCommonCd = async (cdPid: number) => {
  try {
    const url = `/commonCd/${cdPid}`;
    const response = await instance.get<TApiResponseData<ICommonCd[]>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/* 서비스 제어 */
export const getServiceControl = async (page: string) => {
  try {
    const url = `/serviceControl/${page}`;
    const response = await instance.get<TApiResponseData<IServiceControl>>(url);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
